export const isValidUsername = (str: string) => ['admin', 'editor', 'user@example.com', 'test@user.com', 'test@email.com'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)
